var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoThales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 484,
    height: 150,
    viewBox: "0 0 484 57.4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Thales") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".logoSt2{fill:#2C2F73;}\n\t.logoSt4{fill:#5EBFD4;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m484 42.1c0 7.8-2.3 10.1-8.5 12-6.7 2-18.6 3.3-25.7 3.3-8.4 0-18.9-0.5-27.8-2.6v-9h49.3v-12.3h-34.9c-10.5 0-14.4-2.9-14.4-13.1v-5.4c0-8.1 2.4-10.5 8.9-12.2 6.6-1.7 17.4-2.8 24.5-2.8 8.6 0 18.9 0.7 27.8 2.7v9h-48.5v10.3h34.9c10.5 0 14.4 2.8 14.4 13.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m400 54.7c-10.2 2-20.5 2.6-30.5 2.6s-20.4-0.6-30.7-2.6v-52c10.2-2 20.6-2.7 30.5-2.7 10 0 20.1 0.6 30.3 2.7v9.3h-46.2v10.4h30.1v10.8h-30.1v12.3h46.4v9.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m321 54.7c-9.2 2-18.4 2.6-27.3 2.6s-18.3-0.5-27.5-2.6v-53.4h14.7v43.5h40.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m249 55.1c-4.9 1.4-11.4 1.9-16.2 2l-22.7-45.8h-1.3l-22.6 45.8c-4.8-0.1-10.5-0.6-15.4-2l28.7-53.7h20.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt4",
    d: "m219 41.4c0 5.3-4.3 9.5-9.6 9.5s-9.5-4.3-9.5-9.5c0-5.3 4.3-9.5 9.5-9.5 5.3 0 9.6 4.2 9.6 9.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m153 55.1c-4.7 1.4-9.7 1.8-14.7 1.9v-23.3h-36.5v23.3c-5-0.1-10-0.6-14.7-1.9v-52.8c4.7-1.4 9.7-1.8 14.7-1.9v22.5h36.5v-22.5c5 0.1 10 0.6 14.7 1.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "logoSt2",
    d: "m66.2 12.1h-25.8v44h-14.6v-44h-25.8v-9.4c11.1-2 22.3-2.7 33.1-2.7s22 0.6 33.1 2.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoThales);
export default __webpack_public_path__ + "static/media/logo-thales.8a69ee08cde3d866f780388506e12395.svg";
export { ForwardRef as ReactComponent };